import styled from "styled-components";
import { DefaultInput } from "@alboompro/boom-components/data-entry/input/Input";
import {
  PropListItem,
  PropLabel
} from "editor/components/EditorElements/styles";

/**
 * Input field
 */
export const SearchInput = styled(DefaultInput)`
  padding: 0;
  margin: 0;
  img {
    margin-left: 10px;
  }
  input {
    border-radius: 3px;
    padding: 12px 46px;
    font-size: 16px;
    border-color: #B1B1B1;
  }
`;

/**
 * Modal footer
 */
export const FooterContent = styled.div`
  display: flex;
  justify-content: flex-end;

  button:not(:first-child) {
    margin-left: 15px;
  }
  * {
    font-size: 14px;
  }
`;

/**
 * Modal content wraper
 */
export const Wrapper = styled.div`
  height: 70vh;
  display: flex;
  flex: 1;
  flex-direction: column;
  background: #f8f8f8;

  .search-container {
    padding: 20px;
    box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.1);
    z-index: 2;
  }

  .results-listing {
    height: calc(100% - 75px);

    .empty {
      height: 100%;
      background-color: #f7f7f7;
      display: flex;
      align-items: center;
      justify-content: center;

      h1 {
        margin: 0;
        padding: 0;
        font-weight: 300;
        font-size: 23px;
        letter-spacing: 0.5px;
        color: #323232;
      }
    }

    .icon-list {
      > div {
        margin: 5px 20px;
        overflow: visible !important;
      }
      &:focus {
        outline: none;
      }
    }
  }
`;

/**
 * Label container for prop name in edit model
 */
export const CustomPropListItem = styled(PropListItem)`
  flex-direction: column;
`;

export const CustomPropLabel = styled(PropLabel)`
  align-items: flex-start;
  width: 100%;
  margin-bottom: 2px;
`;

/**
 * Row container for the icon displayed in icon picker.
 * the div .icon-container is the individual container for
 * each icon.
 */
export const IconRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  &:after {
    content: "";
    display: block;
    margin-right: auto;
  }

  .icon-container {
    width: 96px;
    height: 96px;
    text-align: center;
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    /* margin: auto; */
    cursor: pointer;

    i {
      font-size: 54px;
      transition: 0.2s all cubic-bezier(0.55, 0.3, 0.5, 0.9);
      color: #363636;
    }

    &:hover {
      background: #efefef;
      border-radius: 5px;
      i {
        font-size: 66px;
      }
    }

    &.active {
      border: 3px solid #44adf8;
      box-sizing: border-box;
      border-radius: 5px;
      position: relative;

      .active-icon {
        width: 20px;
        height: 20px;
        background: #44adf8;
        border-radius: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: -9px;
        left: -9px;
      }

      i {
        font-size: 64px;
      }

      &:hover {
        i {
          font-size: 64px;
        }
      }
    }
  }
`;

export const IconWrapper = styled.div`
  background: #ffffff;
  border: 1px solid #ededed;
  border-radius: 5px;
  padding: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 10px;

  i {
    font-size: 40px;
    color: #484848;
    margin-bottom: 15px;
  }

  .switch {
    display: flex;
    align-items: center;
    height: 25px;
    padding: 1px 12px 2px;
    background-color: #50aff4;
    border-radius: 20px;
    font-size: 12px;
    color: #fff;
    cursor: pointer;

    :focus {
      outline: none;
    }

    :not(:last-child) {
      margin-right: 10px;
    }

    img {
      margin-right: 5px;
    }
  }
`;
